import Button from '../../components/v2/Button/Button';
import { Modal } from '../../components/v2/Modal/Modal';
import { Typography } from '../../components/v2/Typography/Typography';
import { SUPPORT_EMAIL } from '../../constants/brand';
import { usePCO } from '../../provider/pcoProvider';

const PCOSuccessModal = () => {
  const { pcoSuccessModalOpen, setPcoSuccessModalOpen } = usePCO();

  return (
    <Modal
      isOpen={pcoSuccessModalOpen}
      onClose={() => setPcoSuccessModalOpen(false)}
      showCloseButton={true}
      title={''}
    >
      <div className='max-w-[500px] flex flex-col justify-center items-center text-center'>
        <Typography type='display-100' className='max-w-[436px] mt-6'>
          We will reach out if we need any other information to fulfill this
          order!
        </Typography>
        <Typography
          type='body-400'
          variant='functional-low'
          className='mt-6 max-w-[436px]'
        >
          Please allow up to 1 month to receive your requested documents.
        </Typography>
        <Typography
          type='body-400'
          variant='functional-low'
          className='mt-2 max-w-[436px]'
        >
          <>
            If you need them sooner, please reach out to{' '}
            <a className='underline' href={`mailto:${SUPPORT_EMAIL}`}>
              {SUPPORT_EMAIL}
            </a>
          </>
        </Typography>
        <Button
          className='mt-8'
          onClick={() => setPcoSuccessModalOpen(false)}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default PCOSuccessModal;
